export const isRovoSystemSpaceKey = (spaceKey?: string | null) => {
	if (!spaceKey) {
		return false;
	}
	return spaceKey.startsWith('~ROVO') && spaceKey.endsWith('~');
};
